<template>
  <div v-if="isVisible" class="cookie-banner" role="dialog" aria-live="polite" aria-label="Informacja o plikach cookies">
    <div class="cookie-content">
      <div class="cookie-text">
        <p>
          Używamy plików cookies, aby zapewnić prawidłowe działanie strony oraz usprawnić kontakt z klientami.
          Możesz wybrać tylko niezbędne pliki cookies lub zaakceptować także cookies analityczne.
          Szczegóły znajdziesz w <router-link :to="{ name: 'PrivacyPolicy' }">Polityce prywatności i cookies</router-link>.
        </p>
      </div>

      <div class="cookie-actions">
        <button class="btn btn-secondary" @click="openPreferences">Dostosuj</button>
        <button class="btn" @click="acceptAll">Akceptuję</button>
        <button class="btn btn-outline" @click="rejectOptional">Tylko niezbędne</button>
      </div>

      <div v-if="showPreferences" class="cookie-preferences" role="dialog" aria-label="Ustawienia cookies">
        <h3>Ustawienia plików cookies</h3>
        <p>Wybierz cele, na które wyrażasz zgodę:</p>
        <div class="pref-item">
          <label>
            <input type="checkbox" disabled checked /> Niezbędne (zawsze aktywne)
          </label>
        </div>
        <div class="pref-item">
          <label>
            <input type="checkbox" v-model="consent.analytics" /> Analityczne (np. Google Analytics)
          </label>
        </div>
        <div class="pref-actions">
          <button class="btn btn-secondary" @click="closePreferences">Anuluj</button>
          <button class="btn" @click="savePreferences">Zapisz ustawienia</button>
        </div>
        <small class="consent-note">Zapisujemy Twój wybór lokalnie (w przeglądarce) razem z datą i godziną.</small>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue'

const COOKIE_CONSENT_KEY = 'cookie_consent_v1'

export default {
  name: 'CookieConsentBanner',
  setup() {
    const isVisible = computed(() => !localStorage.getItem(COOKIE_CONSENT_KEY))

    const showPreferences = ref(false)
    const consent = ref({ analytics: false })

    const saveConsentToStorage = (categories) => {
      const payload = {
        categories,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent
      }
      localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(payload))
    }

    const acceptAll = () => {
      saveConsentToStorage({ essential: true, analytics: true })
      window.location.reload()
    }

    const rejectOptional = () => {
      saveConsentToStorage({ essential: true, analytics: false })
      window.location.reload()
    }

    const openPreferences = () => {
      const stored = localStorage.getItem(COOKIE_CONSENT_KEY)
      if (stored) {
        try {
          const parsed = JSON.parse(stored)
          consent.value.analytics = !!parsed.categories?.analytics
        } catch (e) {
          consent.value.analytics = false
        }
      }
      showPreferences.value = true
    }

    const closePreferences = () => {
      showPreferences.value = false
    }

    const savePreferences = () => {
      saveConsentToStorage({ essential: true, analytics: !!consent.value.analytics })
      window.location.reload()
    }

    return {
      isVisible,
      acceptAll,
      rejectOptional,
      openPreferences,
      closePreferences,
      savePreferences,
      showPreferences,
      consent
    }
  }
}
</script>

<style lang="scss" scoped>
.cookie-banner {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3000;
  background: rgba(26, 26, 26, 0.98);
  color: white;
  border-top: 1px solid #333;
}

.cookie-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.cookie-text {
  flex: 1 1 60%;
}

.cookie-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
  align-items: center;
}

.cookie-preferences {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 80px;
  background: #fff;
  color: #222;
  padding: 18px;
  border-radius: 8px;
  box-shadow: 0 6px 30px rgba(0,0,0,0.2);
  width: 90%;
  max-width: 640px;
}

.pref-item {
  margin: 10px 0;
}

.pref-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 12px;
}

.consent-note {
  display: block;
  margin-top: 8px;
  color: #666;
  font-size: 0.9rem;
}

.btn-outline {
  background: transparent;
  border: 1px solid #666;
  color: white;
  padding: 10px 14px;
}

@media (max-width: 768px) {
  .cookie-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .cookie-actions {
    width: 100%;
    justify-content: flex-start;
  }
}
</style>
